import axios from 'axios';
import qs from 'query-string';
import {
  API_URL,
  PERFORM_URL,
  REDIRECT_URI,
  SSO_URL,
} from './config';
import {getToken} from './jwt.service';

export const SsoService = {
  init() {
    axios.defaults.baseURL = API_URL;
    axios.interceptors.request.use(
      (config) => {
        const token = getToken();
        if (token) {

          config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
      },
      (error) => {
        Promise.reject(error);
      },
    );
    axios.interceptors.response.use(undefined, (err) => {
      const { config, message } = err;
      if (!config || !config.retry) {
        return Promise.reject(err);
      }
      // retry while Network timeout or Network Error
      if (!(message.includes('status code 500') || message.includes('timeout') || message.includes('Network Error'))) {
        return Promise.reject(err);
      }
      config.retry -= 1;
      const delayRetryRequest = new Promise((resolve) => {
        setTimeout(() => {
          resolve();
        }, config.retryDelay || 1000);
      });
      return delayRetryRequest.then(() => axios(config));
    });
  },
  getIdToken(code) {
    const params = new URLSearchParams(
      {
        redirect_uri: REDIRECT_URI,
        code,
      }
    );
    return axios.post('/api/front/v1/public/get_id_token',params)
      .catch((error) => {
        throw new Error(`[RWV] SsoService ${error}`);
      });
  },
  loginForm(params) {
    return axios.post('/api/front/v1/public/login', new URLSearchParams(params).toString());
  },
  verifyToken(idToken) {
    const requestBody = {
      id_token: idToken,
      renew: 1,
    };
    const config = {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    };
    return axios.post(`${SSO_URL}/api/verify/token`, qs.stringify(requestBody), config).catch((error) => {
      throw new Error(`[RWV] SsoService ${error}`);
    });
  },
  updatePassword(password, newPassword) {
    const requestBody = {
      token: getToken(),
      password,
      new_password: newPassword,
      confirm_password: newPassword,
    };
    const config = {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    };
    return axios.put(`${SSO_URL}/api/oidc/password`, qs.stringify(requestBody), config);
  },
  updateLocale(locale) {
    const requestBody = {
      locale,
    };
    const config = {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    };
    return axios.post(`${PERFORM_URL}/api/front/account/locale`, qs.stringify(requestBody), config);
  },
};

const ApiService = {
  query(resource, params, retry = 3) {
    return axios.get(`/api/${resource}`, {
      retry,
      params,
    });
  },

  downloadQuery(resource, params) {
    return axios.get(`/api/${resource}`, {
      params,
      responseType: 'blob',
    });
  },

  get(resource) {
    return axios.get(`/api/${resource}`);
  },

  post(resource, params, retry = 3) {
    return axios.post(`/api/${resource}`, params, { retry });
  },

  postFile(resource, params) {
    return axios.post(`/api/${resource}`, params,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
  },

  put(resource, params) {
    return axios.put(`/api/${resource}`, params);
  },

  delete(resource, params) {
    return axios.delete(`/api/${resource}`, {
      params,
    });
  },
};

export default ApiService;
